import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import styles from "../../../../src/content/buses-for-ethiopia/styles";
import "../../../../src/content/buses-for-ethiopia/ethiopia-buses.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  styles,
  React
};